<template>
    <div>
        
            <b-row class="justify-content-center">
                <b-col sm="12" lg="8" xl="7">
                    <b-card class="text-center">
                        <ComponentBillboard />
                    </b-card>
                    <b-card class="card-accent-primary " header="Mídias">
                        <ComponentMedia/>
                    </b-card>
                    <b-card class="card-accent-primary " header="Notícias">
                        <ComponentNews/>
                    </b-card>
                    
                    <b-card class="card-accent-primary " header="Documentos e Procedimentos" >
                        <ComponentDocument />
                    </b-card>
                    <b-card class="text-center">
                        <ComponentGallery />
                    </b-card>
                    <b-card class="card-accent-primary " header="Telefones e Ramais" >
                        <ComponentPhone />
                    </b-card>
                
                </b-col>

                <b-col sm="12" lg="4" xl="3">

                    <b-card class="text-center static-left">
                        <ComponentUser v-show="this.$store.state.currentUser.id" />
                        <div v-show="!this.$store.state.currentUser.id">
                            <button class="border-0 bg-transparent text-secondary" @click="$router.push({ path: '/pages/login' })"><i class="fa fa-user-o fa-lg text-secondary" title="Entrar no Sistema"></i> Entrar no Sistema</button>
                            <!--
                            <button class="border-0 bg-transparent" @click="openUserModal()"><i class="fa fa-vcard-o fa-lg text-secondary" title="Registrar usuário"></i></button>
                            -->
                        </div>
                    </b-card>
                    
                    <b-card class="text-center static-left">
                        <ComponentToday />
                    </b-card>
        
                    <b-card class="text-center static-left">
                        <ComponentCalendar />
                    </b-card>
                    
                    <b-card class="card-accent-primary text-center static-left" header="Aniversariantes do Mês">
                        <!-- <ComponentAnniversary v-show="this.$store.state.currentUser.id" /> -->
                        <ComponentAnniversary />                   
                    </b-card>
                    
                    <b-card class="card-accent-primary text-center static-left" header="Caixa de Sugestões">
                        <ComponentSuggestion />
                    </b-card>
        
                    <b-card class="card-accent-primary text-center static-left" header="Links Externos">
                        <ComponentExternalLinks />
                    </b-card>
                                        
                    <b-card class="card-accent-primary static-left" header="Cotações de Moedas">
                        <ComponentInvesting />
                    </b-card>

                    <b-card class="card-accent-primary static-left" header="Previsão do Tempo">
                        <ComponentWeather />
                    </b-card>

                </b-col>

            </b-row>
        
    </div>
    

 </template>
 
 
 <script>
 
 import ComponentUser from '@/views/dash/ComponentUser';
 import ComponentMedia from './dash/ComponentMedia.vue';
 import ComponentSuggestion from '@/views/dash/ComponentSuggestion';
 import ComponentBillboard from '@/views/dash/ComponentBillboard';
 import ComponentNews from '@/views/dash/ComponentNews';
 import ComponentPhone from '@/views/dash/ComponentPhone';
 import ComponentDocument from '@/views/dash/ComponentDocument';
 
 import ComponentToday from '@/views/dash/ComponentToday';
 import ComponentCalendar from '@/views/dash/ComponentCalendar';
 import ComponentAnniversary from '@/views/dash/ComponentAnniversary';
 import ComponentWeather from '@/views/dash/ComponentWeather';
 import ComponentExternalLinks from '@/views/dash/ComponentExternalLinks';
 import ComponentInvesting from '@/views/dash/ComponentInvesting';
 import ComponentGallery from '@/views/dash/ComponentGallery';
 
 export default {
     name: 'intranet',
     components: {
         ComponentUser,
         ComponentSuggestion,
         ComponentAnniversary,
         ComponentToday,
         ComponentCalendar,
         ComponentBillboard,
         ComponentDocument,
         ComponentPhone,
         ComponentWeather,
         ComponentExternalLinks,
         ComponentInvesting,
         ComponentNews,
         ComponentGallery,
         ComponentMedia
     },
     data: function() {
         return {
         }
     },
     methods: {
     },
     mounted: function() {
        
        if(this.$store.state.config.loginRedirect==1) {
            if(!this.$store.state.currentUser.id) {
                this.$router.push({ path: '/pages/login' })
            }
        }
        
     }
     
 }
 
 </script>
 
 <style scoped>

.static-left {
    min-width: 330px;
}

 /*
    #wrapper {
         display:flex;    
         width:100%;
         align-content: streach;
         justify-content: space-between;
     }    
 
     #wrapper div {
         //* height:100px; * /
     }
 
     .staticMain {
         flex: 0 0 800px;
     }
     .staticLeft {
         flex: 0 0 330px;
     }
 
     .staticDiv {
         flex: 0 0 10px;
     }
 
     .growMax {
         flex-grow: 1;
     }
 */
 </style>
 
